module.exports = __webpack_public_path__ + "img/res3.9e2a159f.png";